import { Injectable, inject } from '@angular/core';
import { SupabaseClient } from '@supabase/supabase-js';
import { FinanceTransfer } from '@app/model/finance-transfer';
import { SUPABASE_CLIENT } from '@app/providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class FinanceTransferService {

  financeTransfer: FinanceTransfer = new FinanceTransfer('', '', new Date(), '', '', 0, false, '');

  private supabaseClient: SupabaseClient;

  constructor() {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  async getFinanceTransferForSender(userId: string) {
    return this.supabaseClient
      .from('financial_transfer')
      .select('*')
      .eq('sent_from', userId);
  }

  async getFinanceTransferForReceiver(userId: string) {
    return this.supabaseClient
      .from('financial_transfer')
      .select('*')
      .eq('sent_to', userId);
  }

  async getAllDonateCoinRecordByRecieverId(recieverId: string) {
    const res = await this.supabaseClient.from('financial_transfer').select('*').eq('transfer_type', 'donate').eq('sent_to', recieverId);
    return res?.data;
  }
}
